import { DataPage, DataStore } from "@xbs/muon";
import { IAction, IActionConfig, SpreadsheetEvents } from "../types";

export class Clear implements IAction {
	public config: IActionConfig;
	private _data: any;

	constructor(config: IActionConfig) {
		this.config = config;
	}

	do() {
		const { spreadsheet } = this.config;
		this._data = spreadsheet.serialize();
        spreadsheet.parse([]);
	}

	undo() {
		const { spreadsheet } = this.config;
        spreadsheet.parse(this._data);
	}
}
